import React, { Component } from "react";
import { goBack, executePost, executeGet } from "../functions/Kubuku";
import {
  TITIK_BACA,
  TITIK_BACA_REKOMENDASI,
  TITIK_BACA_CEKLOKASI,
  TITIK_BACA_RETURN_BOOK,
  BASE_URL,
} from "../api";
import Glider from "react-glider";
import "glider-js/glider.min.css";

import ModalLoading from "../components/ModalLoading";

import { useParams, useNavigate } from "react-router-dom";
import image_location from "../assets/images/location.png";
import LoadingScreen from "../components/LoadingScreen";
import { disableSplashScreen } from "../api/enkripsi";

function WithNavigate(props) {
  let navigate = useNavigate();
  return <ReadingBooks {...props} navigate={navigate} params={useParams()} />;
}

class ReadingBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isModal: false, //popup loading
      showMain: false,
      params: this.props.params,
      data: "",
      alias: this.props.params.alias, //window.localStorage.getItem('alias'),
      lokasi: "",
      lat: "", // '-7.557130246009252',
      long: "", // '110.79448368501073',
      alt: "1",
      isOpen: false,
      flagBaca: false,
      flagBuku: false,
      flagNoBook: false,
      flagJauh: false,
      trxBaca: 0,
      msgJauh:
        "Maaf saat ini anda sudah diluar jangkauan baca, silahkan pilih titik baca di sekitar anda.",
      urlbuku: "",
      hdr: this.props.params.judul,
      msgTitleNoData: "Stok Buku Kosong",
      msgNoData:
        "Saat ini semua buku ini sedang dibaca oleh teman-teman anda, silahkan plilih buku yang lain.",
      color: "bg-orange",
      darkcolor: "bg-orang-dark",
      textcolor: "text-orange",
      imgHead: "",
      imgSplash: "",
      bottom: "bottom-20",
      whidden: "",
      tap: 0,
      loadingScreen: false,
    };
    this.inactivityTimer = null;
    this.timer = null;
  }

  componentDidMount = async () => {
    this.checkAndHandle();
    this.getLocation();
    this.getTheme();
    disableSplashScreen();
    if (this.props.params.token != "REG") {
      this.setState({
        bottom: "bottom-2",
      });
    }

    if (localStorage.getItem("sn") !== null) {
      // Tambahkan event listeners
      window.addEventListener("mousemove", this.handleUserActivity);
      window.addEventListener("scroll", this.handleUserActivity);
      window.addEventListener("click", this.handleUserActivity);

      // Set timer awal
      this.resetTimer();
    }
    this.locationInterval = setInterval(() => {
      this.getLocation();
    }, 600000); // 10 menit
  };

  componentDidUpdate(prevProps) {
    if (prevProps.params.id !== this.props.params.id) {
      this.checkAndHandle();
    }
  }

  componentWillUnmount() {
    clearInterval(this.locationInterval);
    // Hapus event listeners dan timer saat komponen di-unmount
    if (this.timer) {
      clearTimeout(this.timer);
    }
    window.removeEventListener("mousemove", this.handleUserActivity);
    window.removeEventListener("scroll", this.handleUserActivity);
    window.removeEventListener("click", this.handleUserActivity);
    clearTimeout(this.inactivityTimer); // Bersihkan timer
  }
  // Fungsi untuk mengatur ulang timer
  resetTimer = () => {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
    this.inactivityTimer = setTimeout(() => {
      this.setState({ loadingScreen: true });
    }, 60000); // 60000ms = 1 menit
  };

  checkAndHandle = () => {
    const { params } = this.props;

    if (!params.id) return;

    const sn = localStorage.getItem("sn");
    if (sn && sn !== "null") {
      this.timer = setTimeout(() => {
        this.handleHiddenButtonNav();
      }, 200);
    }
  };

  // Event listener untuk mendeteksi aktivitas pengguna
  handleUserActivity = () => {
    if (this.state.loadingScreen == true) {
      // Redirect ke halaman home jika loading aktif dan pengguna beraktivitas
      this.returnBook();
      this.setState({ isLoading: false });
      window.location.href = "/home/" + this.props.params.alias; // Ubah ini sesuai rute halaman home Anda
    } else {
      // Hanya reset timer ketika isLoading masih false
      this.resetTimer();
    }
  };

  returnBook = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const json = await executeGet(
        TITIK_BACA_RETURN_BOOK + this.state.trxBaca
      ); //, formData);
      if (json.code == 404) {
        this.setState({
          isLoading: false,
        });
        window.location.href = "https://titikbaca.id";
      } else {
        this.setState({
          isLoading: false,
        });
        goBack();
      }
    } catch (error) {
      this.setState({
        isLoading: false,
      });
      //console.log(error);
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  getTheme = async () => {
    try {
      //const json = await executeGet(TITIK_BACA_GET_THEMES + alias);
      if (window.localStorage.getItem("themes") != null) {
        const ljson = window.localStorage.getItem("themes");
        const json = JSON.parse(ljson);
        if (json.code == 200) {
          if (json.warna != "") {
            this.setState({
              color: json.warna,
            });
          }
          if (json.dark != "") {
            this.setState({
              darkcolor: json.dark,
            });
          }
          if (json.text != "") {
            this.setState({
              textcolor: json.text,
            });
          }
          if (json.head != "") {
            this.setState({
              imgHead: json.head,
            });
          }
          if (json.splash != "") {
            this.setState({
              imgSplash: json.splash,
            });
          }
        }
      }
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };
  getLocation = () => {
    const lat = localStorage.getItem("lat");
    const long = localStorage.getItem("long");
    const alt = localStorage.getItem("alt");

    // 1️⃣ Kalau sudah ada lokasi di localStorage → langsung validasi
    if (lat && long) {
      this.validasiLokasi(lat, long, alt);
      return;
    }

    // 2️⃣ Kalau nggak ada geolocation → gagal
    if (!navigator.geolocation) {
      this.geolocFail();
      return;
    }

    // 3️⃣ Ambil lokasi cepat (cache)
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const long = pos.coords.longitude;
        const alt = pos.coords.altitude;

        this.setState({ lat, long, alt });
        localStorage.setItem("lat", lat);
        localStorage.setItem("long", long);
        localStorage.setItem("alt", alt);

        this.validasiLokasi(lat, long, alt);
      },
      (err) => console.warn("Gagal ambil lokasi cache:", err),
      { enableHighAccuracy: false, timeout: 3000, maximumAge: Infinity }
    );
  };

  validasiLokasi = async (lat, long, alt) => {
    if (this.props.params.token == "REG") {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("alt", "1");
      const json = await executePost(
        TITIK_BACA_CEKLOKASI + this.props.params.alias,
        formData
      );
      if (json.code == 400) {
        this.getTitikBacaTerdekat(lat, long, alt);
      } else {
        if (this.state.isOpen == false) {
          this.bacaBuku(lat, long, alt);
        }
      }
      if (window.localStorage.getItem("sn") == null) {
        let interval = setInterval(async (lat, long) => {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              let latx = position.coords.latitude;
              let longx = position.coords.longitude;
              let altx = position.coords.altitude;

              let formData = new FormData();
              formData.append("latitude", latx);
              formData.append("longitude", longx);
              formData.append("alt", altx);
              formData.append("trx_baca", this.state.trxBaca);
              const json = await executePost(
                TITIK_BACA_CEKLOKASI + this.props.params.alias,
                formData
              );
              if (json.code == 400) {
                this.setState({
                  flagBaca: false,
                });
                try {
                  let formData = new FormData();
                  formData.append("latitude", latx);
                  formData.append("longitude", longx);
                  const jsonx = await executePost(TITIK_BACA, formData);
                  this.setState({
                    isLoading: false,
                    flagJauh: true,
                    dataterdekat: jsonx,
                  });
                } catch (error) {
                  this.setState({
                    isError: true,
                    errorMessage: "Network Error!",
                  });
                }
                clearInterval(interval);
              }
            },
            (error) => {
              //clearTimeout(location_timeout);
              //this.geolocFail()
            }
          );
        }, 30000);
      }
    } else {
      this.bacaBuku(lat, long, alt);
    }
  };

  getTitikBacaTerdekat = async (lat, long, alt) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      const json = await executePost(TITIK_BACA, formData);
      this.setState({
        isLoading: false,
        flagJauh: true,
        dataterdekat: json,
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  tapHandler = () => {
    this.setState({
      whidden: "hidden",
    });
  };

  getBukuRekomendasi = async (lat, long) => {
    try {
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("isMobile", "1");
      const json = await executePost(
        TITIK_BACA_REKOMENDASI + this.state.alias,
        formData
      );
      this.setState({
        data: json.data,
        flagBuku: true,
      });
    } catch (error) {
      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };

  bacaBuku = async (lat, long, alt) => {
    try {
      this.setState({
        isLoading: true,
      });
      let formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", long);
      formData.append("altitude", alt);
      formData.append("isMobile", "1");
      formData.append("tokensms", this.props.params.token);
      if (this.state.params.tipe == "11") {
        var json = await executeGet(
          BASE_URL + "bacaBukuLokal/" + this.state.params.id
        );
      } else {
        var json = await executePost(
          BASE_URL +
            "bacaBuku/" +
            this.state.alias +
            "/" +
            this.state.params.id,
          formData
        );
      }

      if (json.code == 404) {
        window.location.href = "https://titikbaca.id";
      } else if (json.code == 201) {
        //alert(json.code + ' Maaf semua buku sedang dibaca teman-teman anda, mohon tunggu')
        this.setState({
          isLoading: false,
          flagNoBook: true,
        });
      } else {
        if (this.state.params.tipe == "11") {
          this.setState({
            flagBaca: true,
            flagNoBook: false,
            isLoading: false,
            isOpen: true,
            trxBaca: json.id_trx_baca,
            urlbuku:
              "https://kubuku.id/api/konten/devel/index.php?url=" +
              json.data.url_octet_stream,
          });
        } else {
          this.setState({
            flagBaca: true,
            flagNoBook: false,
            isLoading: false,
            isOpen: true,
            trxBaca: json.id_trx_baca,
            urlbuku:
              "https://kubuku.id/api/konten/devel/index.php?url=" +
              json.url +
              json.jwt,
          });
        }
      }
      //this.getBukuRekomendasi();
    } catch (error) {
      //console.log(error);

      this.setState({ isError: true, errorMessage: "Network Error!" });
    }
  };
  closeError = async () => {
    this.setState({ isError: false, errorMessage: "" });
  };
  gotoDetail = async (id) => {
    window.location.href = "/detailBuku/" + id + "/" + this.state.alias;
  };

  handleHiddenButtonNav = () => {
    if (window.electron && window.electron.sendMessage) {
      window.electron.sendMessage("READINGBOOK_MENU", { dummy: 1 });
    } else {
      console.error("window.electron or sendMessage is undefined");
    }
  };

  render() {
    return (
      <>
        {this.state.loadingScreen ? (
          <LoadingScreen />
        ) : (
          <div className="h-full">
            <nav className="fixed top-0 w-full z-10 shadow-md">
              <div
                onClick={() => this.returnBook()}
                className={
                  "flex p-4 " +
                  this.state.color +
                  " text-lg text-white font-semibold items-center"
                }
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-8"
                >
                  <path
                    d="M15 6L9 12L15 18"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="line-clamp-1 ">{this.state.hdr}</span>
              </div>
            </nav>
            {this.state.isLoading && <ModalLoading />}
            {this.state.isError && (
              <>
                <div className="block">
                  <div className="flex h-screen overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="w-[60%] h-[120px] mx-auto">
                      {/*content*/}
                      <div className="flex justify-center items-center h-screen">
                        <div className="p-4 border-0 rounded-lg shadow-lg w-full bg-white outline-none focus:outline-none m-auto">
                          <div className="text-center mt-4 font-semibold text-black">
                            Maaf, {this.state.errorMessage}
                          </div>
                          <div>
                            <button
                              onClick={() => this.closeError()}
                              type="button"
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
              </>
            )}
            {this.state.flagJauh && (
              <>
                <div className="mt-16">
                  <div className="px-4">
                    <div
                      className={
                        "relative mb-2.5 p-4 " +
                        this.state.color +
                        " text-white rounded-2xl shadow-md overflow-hidden"
                      }
                    >
                      <div className="w-52 sm:w-96 md:w-auto">
                        <p className="mb-3 text-sm font-semibold">
                          {this.state.msgJauh}
                        </p>
                      </div>
                      <svg
                        width="64"
                        height="68"
                        viewBox="0 0 64 68"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="absolute right-2.5 top-1 z-10"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.6379 67.2934C11.1472 67.2934 24.8452 63.913 24.8452 63.913L38.4521 62.7157L55.4457 62.4841L49.3253 29.5515L45.2892 20.5968L10.6379 62.3136C10.6379 62.3136 9.344 67.2934 10.6379 67.2934Z"
                          fill="url(#paint0_linear_176_439)"
                        />
                        <mask
                          id="path-2-outside-1_176_439"
                          maskUnits="userSpaceOnUse"
                          x="1.61022"
                          y="15.8526"
                          width="52.6296"
                          height="52.6296"
                          fill="black"
                        >
                          <rect
                            fill="white"
                            x="1.61022"
                            y="15.8526"
                            width="52.6296"
                            height="52.6296"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M32.515 24.8062L45.4709 18.1441C45.6726 18.0404 45.9167 18.1642 45.9522 18.3882L51.6594 54.4217C51.6819 54.5638 51.6106 54.7043 51.4827 54.7701L38.4566 61.4683C38.4141 61.4901 38.3697 61.5019 38.3257 61.5047C38.2838 61.515 38.2388 61.5173 38.1926 61.5098L23.8116 59.1773L10.8553 65.8397C10.6536 65.9434 10.4094 65.8196 10.3739 65.5955L4.66678 29.562C4.64427 29.42 4.71552 29.2795 4.84346 29.2137L17.8696 22.5155C17.9117 22.4938 17.9556 22.4821 17.9991 22.4791C18.0415 22.4685 18.087 22.4661 18.1337 22.4736L32.515 24.8062Z"
                          />
                        </mask>
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.515 24.8062L45.4709 18.1441C45.6726 18.0404 45.9167 18.1642 45.9522 18.3882L51.6594 54.4217C51.6819 54.5638 51.6106 54.7043 51.4827 54.7701L38.4566 61.4683C38.4141 61.4901 38.3697 61.5019 38.3257 61.5047C38.2838 61.515 38.2388 61.5173 38.1926 61.5098L23.8116 59.1773L10.8553 65.8397C10.6536 65.9434 10.4094 65.8196 10.3739 65.5955L4.66678 29.562C4.64427 29.42 4.71552 29.2795 4.84346 29.2137L17.8696 22.5155C17.9117 22.4938 17.9556 22.4821 17.9991 22.4791C18.0415 22.4685 18.087 22.4661 18.1337 22.4736L32.515 24.8062Z"
                          fill="#ADE1F1"
                        />
                        <path
                          d="M45.4709 18.1441L46.0802 19.3291L46.0802 19.3291L45.4709 18.1441ZM32.515 24.8062L32.3016 26.1215L32.7344 26.1917L33.1243 25.9912L32.515 24.8062ZM45.9522 18.3882L44.6361 18.5967L45.9522 18.3882ZM51.6594 54.4217L52.9755 54.2133L51.6594 54.4217ZM51.4827 54.7701L50.8733 53.5851L50.8733 53.5851L51.4827 54.7701ZM38.4566 61.4683L37.8472 60.2832L37.8472 60.2832L38.4566 61.4683ZM38.3257 61.5047L38.2399 60.175L38.1219 60.1826L38.0071 60.2109L38.3257 61.5047ZM38.1926 61.5098L38.406 60.1945L38.4059 60.1945L38.1926 61.5098ZM23.8116 59.1773L24.025 57.862L23.5922 57.7918L23.2023 57.9923L23.8116 59.1773ZM10.8553 65.8397L10.2459 64.6546L10.2459 64.6546L10.8553 65.8397ZM10.3739 65.5955L9.05782 65.804L10.3739 65.5955ZM4.66678 29.562L5.98287 29.3536L4.66678 29.562ZM4.84346 29.2137L5.45281 30.3987L5.45281 30.3987L4.84346 29.2137ZM17.8696 22.5155L18.4789 23.7005L18.4789 23.7005L17.8696 22.5155ZM17.9991 22.4791L18.0902 23.8085L18.2087 23.8004L18.3238 23.7715L17.9991 22.4791ZM18.1337 22.4736L17.9204 23.789L17.9204 23.789L18.1337 22.4736ZM44.8615 16.9591L31.9056 23.6212L33.1243 25.9912L46.0802 19.3291L44.8615 16.9591ZM47.2683 18.1798C47.0909 17.0596 45.8701 16.4404 44.8615 16.9591L46.0802 19.3291C45.475 19.6403 44.7426 19.2688 44.6361 18.5967L47.2683 18.1798ZM52.9755 54.2133L47.2683 18.1798L44.6361 18.5967L50.3433 54.6302L52.9755 54.2133ZM52.092 55.9551C52.7317 55.6262 53.088 54.9237 52.9755 54.2133L50.3433 54.6302C50.2757 54.2039 50.4895 53.7824 50.8733 53.5851L52.092 55.9551ZM39.0659 62.6533L52.092 55.9551L50.8733 53.5851L37.8472 60.2832L39.0659 62.6533ZM38.4116 62.8345C38.6358 62.82 38.8587 62.7599 39.0659 62.6533L37.8472 60.2832C37.9695 60.2204 38.1035 60.1838 38.2399 60.175L38.4116 62.8345ZM37.9793 62.8251C38.2046 62.8617 38.4305 62.8512 38.6444 62.7986L38.0071 60.2109C38.1371 60.1789 38.2731 60.173 38.406 60.1945L37.9793 62.8251ZM23.5983 60.4926L37.9793 62.8251L38.4059 60.1945L24.025 57.862L23.5983 60.4926ZM11.4646 67.0247L24.421 60.3623L23.2023 57.9923L10.2459 64.6546L11.4646 67.0247ZM9.05782 65.804C9.23524 66.9242 10.456 67.5433 11.4646 67.0247L10.2459 64.6546C10.8511 64.3434 11.5836 64.7149 11.69 65.3871L9.05782 65.804ZM3.35068 29.7705L9.05782 65.804L11.69 65.3871L5.98287 29.3536L3.35068 29.7705ZM4.23412 28.0287C3.59442 28.3576 3.23815 29.06 3.35068 29.7705L5.98287 29.3536C6.05039 29.7799 5.83662 30.2013 5.45281 30.3987L4.23412 28.0287ZM17.2602 21.3305L4.23411 28.0287L5.45281 30.3987L18.4789 23.7005L17.2602 21.3305ZM17.908 21.1497C17.686 21.165 17.4655 21.2249 17.2602 21.3305L18.4789 23.7005C18.3579 23.7628 18.2252 23.7993 18.0902 23.8085L17.908 21.1497ZM18.3471 21.1583C18.119 21.1213 17.8905 21.1325 17.6744 21.1868L18.3238 23.7715C18.1925 23.8045 18.0549 23.8108 17.9204 23.789L18.3471 21.1583ZM32.7283 23.4909L18.3471 21.1583L17.9204 23.789L32.3016 26.1215L32.7283 23.4909Z"
                          fill="url(#paint1_linear_176_439)"
                          mask="url(#path-2-outside-1_176_439)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.66673 29.5618C4.64423 29.4197 4.71548 29.2792 4.84342 29.2134L17.8695 22.5152C18.0712 22.4115 18.3154 22.5353 18.3509 22.7594L24.058 58.7928C24.0805 58.9349 24.0093 59.0754 23.8813 59.1412L10.8552 65.8394C10.6535 65.9431 10.4094 65.8193 10.3739 65.5952L4.66673 29.5618Z"
                          fill="#ADE1F1"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.09232 51.4391C8.06938 51.2967 8.14064 51.1558 8.26886 51.0898L21.2955 44.3914C21.4969 44.2878 21.7407 44.4111 21.7767 44.6346L24.0574 58.7925C24.0803 58.9349 24.0091 59.0758 23.8808 59.1418L10.8542 65.8402C10.6528 65.9438 10.409 65.8205 10.373 65.597L8.09232 51.4391Z"
                          fill="#ADF1AF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.2675 25.1904C32.245 25.0483 32.3162 24.9078 32.4442 24.842L45.4703 18.1438C45.672 18.0401 45.9161 18.1639 45.9516 18.388L51.6588 54.4214C51.6813 54.5635 51.61 54.704 51.4821 54.7698L38.456 61.468C38.2542 61.5717 38.0101 61.4479 37.9746 61.2238L32.2675 25.1904Z"
                          fill="#ADE1F1"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M35.7741 47.4515L40.9383 49.9914L49.948 45.6178C50.1508 45.5193 50.3908 45.6466 50.4231 45.8697L51.6627 54.4244C51.6831 54.5652 51.6118 54.7034 51.4853 54.7684L38.4557 61.4684C38.2541 61.5721 38.0102 61.4485 37.9744 61.2247L35.7741 47.4515Z"
                          fill="#ADF1AF"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.8678 25.0954C32.8453 24.9533 32.7341 24.8417 32.5921 24.8187L18.1337 22.4737C17.9098 22.4373 17.7159 22.6305 17.7514 22.8546L23.4585 58.8881C23.481 59.0302 23.5922 59.1417 23.7342 59.1648L38.1926 61.5098C38.4165 61.5462 38.6104 61.3529 38.575 61.1289L32.8678 25.0954Z"
                          fill="#9AD6E9"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M32.0645 46.6664C31.9427 46.6323 31.8508 46.5321 31.8272 46.4078L30.3691 38.7273L20.521 37.13C20.2975 37.0937 20.1037 37.2862 20.1385 37.5099L23.4589 58.8872C23.481 59.0297 23.5924 59.1418 23.7347 59.1649L38.1938 61.5101C38.4173 61.5463 38.6111 61.3539 38.5763 61.1301L36.524 47.9167L32.0645 46.6664Z"
                          fill="#9AE99C"
                        />
                        <path
                          d="M7.23277 51.1431L20.676 44.7826L19.2484 36.6147L22.622 37.2337L30.6277 38.166L31.9741 46.7593L35.9355 47.4374L40.8225 49.9634L50.9682 45.1766"
                          stroke="white"
                          strokeWidth="1.99876"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19.2552 39.0684L13.969 37.8863L12.7439 30.9982L15.9964 29.1204L15.2151 23.5279"
                          stroke="white"
                          strokeWidth="0.999378"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.7783 48.8492L18.4118 52.3718L22.2743 50.6138L37.0916 53.2579L38.4154 62.3491"
                          stroke="white"
                          strokeWidth="0.999378"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M31.1092 38.1142L29.9326 29.2229L33.4327 30.0079L37.9876 36.2505L45.429 32.8135L47.892 26.0709"
                          stroke="white"
                          strokeWidth="0.999378"
                          stroke-linejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M52.6699 51.4015L26.8934 38.3246L30.717 36.8811L33.2266 38.3246L44.996 21.2019H47.7272L52.6699 51.4015Z"
                          fill="url(#paint2_linear_176_439)"
                        />
                        <path
                          d="M11.3957 9.00499L7.19757 6.21516C6.75746 5.92269 6.16816 6.04226 5.88133 6.48224C5.5945 6.92222 5.71876 7.51599 6.15888 7.80846L10.357 10.5983C10.7971 10.8908 11.3864 10.7712 11.6732 10.3312C11.9601 9.89123 11.8358 9.29746 11.3957 9.00499Z"
                          fill="url(#paint3_linear_176_439)"
                        />
                        <path
                          d="M9.17086 12.5428L4.20095 11.7017C3.67993 11.6136 3.19021 11.9625 3.10714 12.4811C3.02406 12.9997 3.37909 13.4916 3.90011 13.5798L8.87002 14.4209C9.39104 14.5091 9.88075 14.1601 9.96383 13.6415C10.0469 13.1229 9.69188 12.631 9.17086 12.5428Z"
                          fill="url(#paint4_linear_176_439)"
                        />
                        <path
                          d="M15.1263 6.83111L12.8855 2.31599C12.6506 1.84264 12.0805 1.65155 11.6121 1.88917C11.1437 2.12679 10.9544 2.70314 11.1893 3.17648L13.4301 7.6916C13.665 8.16495 14.2352 8.35604 14.7036 8.11842C15.1719 7.8808 15.3612 7.30446 15.1263 6.83111Z"
                          fill="url(#paint5_linear_176_439)"
                        />
                        <path
                          d="M51.8027 10.9513L56.4892 9.09526C56.9805 8.90068 57.532 9.14017 57.7211 9.63017C57.9102 10.1202 57.6652 10.6751 57.1739 10.8697L52.4875 12.7257C51.9962 12.9203 51.4446 12.6808 51.2555 12.1908C51.0664 11.7008 51.3114 11.1459 51.8027 10.9513Z"
                          fill="url(#paint6_linear_176_439)"
                        />
                        <path
                          d="M53.2436 14.8742L58.2797 15.0848C58.8077 15.1069 59.2142 15.55 59.1876 16.0745C59.161 16.5991 58.7115 17.0064 58.1835 16.9843L53.1474 16.7738C52.6194 16.7517 52.2129 16.3086 52.2395 15.784C52.2661 15.2595 52.7156 14.8521 53.2436 14.8742Z"
                          fill="url(#paint7_linear_176_439)"
                        />
                        <path
                          d="M48.606 8.04883L51.7365 4.09826C52.0647 3.6841 52.6621 3.61572 53.0709 3.94553C53.4796 4.27534 53.5449 4.87844 53.2167 5.2926L50.0862 9.24318C49.758 9.65734 49.1606 9.72572 48.7518 9.39591C48.3431 9.0661 48.2778 8.46299 48.606 8.04883Z"
                          fill="url(#paint8_linear_176_439)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M27.3044 11.3795C27.1368 11.3917 26.9686 11.4082 26.8001 11.4289C21.1538 12.1222 17.1478 17.3364 17.8524 23.0753C17.9651 23.9931 18.1915 24.8688 18.5154 25.6895L18.5143 25.6926C20.0497 29.6808 22.891 35.1914 27.765 39.0794C29.209 38.7023 30.5699 38.4799 30.6307 38.4701L29.2529 27.2491C29.0895 27.2859 28.9228 27.3149 28.7531 27.3357C25.9762 27.6767 23.4478 25.6951 23.1058 22.9096C22.7638 20.1242 24.7377 17.5898 27.5145 17.2488C27.6843 17.228 27.8531 17.2158 28.0205 17.212L27.3044 11.3795Z"
                          fill="url(#paint9_linear_176_439)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M24.9399 11.7183C24.7726 11.7307 24.6048 11.7471 24.4365 11.7678C18.7902 12.4611 14.7767 17.6144 15.4721 23.2781C15.6328 24.5866 16.0308 25.8079 16.6174 26.9039C19.7239 33.2724 27.7983 39.1472 27.7983 39.1472C27.7983 39.1472 27.9615 38.9574 28.2418 38.61L26.8551 27.316C26.6919 27.3528 26.5253 27.3818 26.3558 27.4026C23.5789 27.7435 21.0506 25.7619 20.7086 22.9765C20.3665 20.1911 22.3404 17.6566 25.1173 17.3157C25.2868 17.2949 25.4554 17.2827 25.6227 17.2789L24.9399 11.7183Z"
                          fill="url(#paint10_linear_176_439)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M33.7989 11.6568C33.9667 11.6633 34.1353 11.674 34.3044 11.6888C39.9608 12.1836 44.1466 17.1511 43.6538 22.7839C43.5357 24.134 43.1596 25.3997 42.5779 26.5372C40.9217 30.3424 37.868 34.074 33.7141 38.7611C32.9238 38.4632 31.5793 37.9702 31.5793 37.9702C31.5793 37.9702 31.553 37.944 31.5035 37.8933L32.446 27.1207C32.6104 27.1518 32.7778 27.175 32.948 27.1899C35.7298 27.4332 38.1833 25.3624 38.4281 22.5646C38.6729 19.7667 36.6162 17.3013 33.8344 17.0579C33.6642 17.043 33.4953 17.0368 33.328 17.0389L33.7989 11.6568Z"
                          fill="url(#paint11_linear_176_439)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M36.0075 11.7924C36.1749 11.7989 36.3431 11.8095 36.5118 11.8242C42.1681 12.3191 46.35 17.3321 45.8523 23.0211C45.7378 24.3299 45.3856 25.5604 44.8422 26.6734C41.969 33.1573 34.1063 39.326 34.1063 39.326C34.1063 39.326 33.9366 39.1416 33.6444 38.8033L34.6368 27.4597C34.8011 27.4907 34.9684 27.5139 35.1384 27.5288C37.9202 27.7722 40.3737 25.7014 40.6185 22.9035C40.8633 20.1056 38.8066 17.6402 36.0248 17.3968C35.8548 17.382 35.686 17.3757 35.5189 17.3778L36.0075 11.7924Z"
                          fill="url(#paint12_linear_176_439)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_176_439"
                            x1="64.8891"
                            y1="61.0799"
                            x2="59.4697"
                            y2="48.3545"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#C8D4DE" stop-opacity="0.01" />
                            <stop offset="1" stopColor="#DEEAF4" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_176_439"
                            x1="-15.7415"
                            y1="44.4627"
                            x2="22.5739"
                            y2="76.7791"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#EFF6FF" />
                            <stop offset="1" stopColor="white" />
                          </linearGradient>
                          <linearGradient
                            id="paint2_linear_176_439"
                            x1="42.1619"
                            y1="44.7031"
                            x2="28.9671"
                            y2="33.6334"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#80C9C7" stop-opacity="0.01" />
                            <stop offset="1" stopColor="#3E80B3" />
                          </linearGradient>
                          <linearGradient
                            id="paint3_linear_176_439"
                            x1="5.38321"
                            y1="6.63295"
                            x2="8.48295"
                            y2="12.225"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E8F1F5" />
                            <stop offset="1" stopColor="#E5EAF0" />
                          </linearGradient>
                          <linearGradient
                            id="paint4_linear_176_439"
                            x1="2.71338"
                            y1="12.8214"
                            x2="7.81963"
                            y2="16.6692"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E8F1F5" />
                            <stop offset="1" stopColor="#E5EAF0" />
                          </linearGradient>
                          <linearGradient
                            id="paint5_linear_176_439"
                            x1="11.1053"
                            y1="1.77062"
                            x2="10.9938"
                            y2="8.16337"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E8F1F5" />
                            <stop offset="1" stopColor="#E5EAF0" />
                          </linearGradient>
                          <linearGradient
                            id="paint6_linear_176_439"
                            x1="58.177"
                            y1="9.88115"
                            x2="53.9823"
                            y2="14.7066"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E8F1F5" />
                            <stop offset="1" stopColor="#E5EAF0" />
                          </linearGradient>
                          <linearGradient
                            id="paint7_linear_176_439"
                            x1="59.502"
                            y1="16.4893"
                            x2="53.7073"
                            y2="19.1914"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E8F1F5" />
                            <stop offset="1" stopColor="#E5EAF0" />
                          </linearGradient>
                          <linearGradient
                            id="paint8_linear_176_439"
                            x1="53.5912"
                            y1="3.93493"
                            x2="52.3712"
                            y2="10.2112"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#E8F1F5" />
                            <stop offset="1" stopColor="#E5EAF0" />
                          </linearGradient>
                          <linearGradient
                            id="paint9_linear_176_439"
                            x1="18.8644"
                            y1="15.7599"
                            x2="35.4389"
                            y2="29.3181"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FF5E84" />
                            <stop offset="1" stopColor="#E46B80" />
                          </linearGradient>
                          <linearGradient
                            id="paint10_linear_176_439"
                            x1="7.81875"
                            y1="52.7655"
                            x2="28.1367"
                            y2="49.9166"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FFB8C6" />
                            <stop offset="1" stopColor="#FF8194" />
                          </linearGradient>
                          <linearGradient
                            id="paint11_linear_176_439"
                            x1="43.4202"
                            y1="19.2673"
                            x2="27.4514"
                            y2="28.7494"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FFCFD5" />
                            <stop offset="1" stopColor="#FFA2AB" />
                          </linearGradient>
                          <linearGradient
                            id="paint12_linear_176_439"
                            x1="55.2985"
                            y1="51.5483"
                            x2="34.8552"
                            y2="49.7597"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FFB8C6" />
                            <stop offset="1" stopColor="#FF8194" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <div className="absolute right-[-40px] top-[-60px] w-36 h-36 bg-white/50 rounded-full"></div>
                    </div>
                  </div>

                  {/* Title Section */}
                  <div className="flex justify-between px-4 items-center mt-4 mb-2">
                    <h3 className="text-base text-black font-semibold">
                      Silahkan Pilih Titikbaca
                    </h3>
                  </div>
                  {/* End Title Section */}
                  <div className="px-4 mb-16">
                    <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
                      {this.state.alias != "kfh-12f9-kas" && (
                        <>
                          <a href={"/kfh-12f9-kas"}>
                            <div className="text-center">
                              <div className="rounded-full p-4">
                                <img src={image_location} alt="location" />
                              </div>
                              <div className="mt-2 text-sm text-black font-semibold line-clamp-2">
                                PT. Enam Kubuku Indonesia
                              </div>
                            </div>
                          </a>
                        </>
                      )}
                      {this.state.dataterdekat.length > 0 && (
                        <>
                          {this.state.dataterdekat.slice(0, 5).map((item) => {
                            let mySentence = item.nama.toLowerCase();
                            let words = mySentence.split(" ");

                            for (let i = 0; i < words.length; i++) {
                              words[i] =
                                words[i][0].toUpperCase() + words[i].substr(1);
                            }

                            let titik = words.join(" ");
                            if (
                              item.alias != this.state.alias &&
                              item.alias != "kfh-12f9-kas"
                            ) {
                              return (
                                <a href={"/" + item.alias}>
                                  <div className="text-center">
                                    <div className="rounded-full p-4">
                                      <img
                                        src={image_location}
                                        alt="location"
                                      />
                                    </div>
                                    <div className="mt-2 text-sm text-black font-semibold line-clamp-2">
                                      {titik}
                                    </div>
                                  </div>
                                </a>
                              );
                            }
                          })}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            {this.state.flagBaca && (
              <>
                <div style={{ height: "100vh" }} id="readingBook">
                  <iframe
                    src={this.state.urlbuku}
                    className="w-full h-full"
                  ></iframe>
                </div>
                <div
                  onTouchStart={() => this.tapHandler()}
                  className={
                    this.state.whidden +
                    " fixed z-200 w-10/12 mx-auto left-0 right-0 border rounded-lg text-sm text-center p-2"
                  }
                  style={{
                    bottom: "20px",
                    position: "fixed",
                    borderColor: "rgba(252, 106, 48, 0.43)",
                    backgroundColor: "rgba(251, 184, 157, 0.43)",
                  }}
                >
                  Untuk membaca lebih jelas, lakukan double tap layar.
                </div>
              </>
            )}
            {this.state.flagNoBook && (
              <>
                <svg
                  width="211"
                  height="164"
                  viewBox="0 0 211 164"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mt-20 mx-auto"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M114.658 0.284668C95.4486 0.284668 77.7928 6.94349 63.8517 18.0842L41.3202 18.0842C38.3929 18.0842 35.9978 20.4872 35.9978 23.4241C35.9978 26.361 38.3929 28.764 41.3202 28.764L52.7871 28.764L56.1473 28.764C59.0747 28.764 61.4697 31.1669 61.4697 34.1039C61.4697 35.5706 60.8701 36.9091 59.905 37.8738C58.9434 38.8421 57.6092 39.4437 56.1473 39.4437L48.9784 39.4437L45.02 39.4437L25.7079 39.4437C22.7806 39.4437 20.3855 41.8467 20.3855 44.7836C20.3855 47.7205 22.7806 50.1235 25.7079 50.1235L39.5333 50.1235C35.3599 59.9638 33.0482 70.7913 33.0482 82.1627C33.0482 86.2887 33.3533 90.3434 33.9388 94.3056C34.1836 95.961 34.4781 97.6021 34.8223 99.2254C44.8639 97.684 55.5158 96.4451 66.636 95.5409L67.4734 96.3063L68.2611 95.4127C81.6203 94.3697 95.643 93.8143 110.106 93.8143C140.834 93.8143 169.589 96.3205 194.175 100.678C195.122 96.5555 195.761 92.3156 196.062 87.9796C196.201 86.0573 196.268 84.1171 196.268 82.1627C196.268 36.9411 159.732 0.284668 114.658 0.284668"
                    fill="#F1F2F7"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.54662 39.1968L6.32111 39.1968C3.35583 39.1968 0.929687 41.6482 0.929687 44.6445C0.929687 47.6407 3.35583 50.0921 6.32111 50.0921L9.54662 50.0921C12.5119 50.0921 14.938 47.6407 14.938 44.6445C14.938 41.6482 12.5119 39.1968 9.54662 39.1968"
                    fill="#F1F2F7"
                  />
                  <mask
                    id="mask0_180_969"
                    maskUnits="userSpaceOnUse"
                    x="34"
                    y="93"
                    width="177"
                    height="71"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M211 93.9321L211 163.716L122.856 163.716L34.7114 163.716L34.7114 93.9321L211 93.9321V93.9321Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_180_969)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M211 120.912C211 123.831 208.605 126.219 205.679 126.219L171.691 126.219C170.229 126.219 168.896 126.816 167.934 127.779C166.969 128.737 166.37 130.067 166.37 131.525C166.37 134.443 168.764 136.831 171.691 136.831L178.005 136.831C179.467 136.831 180.801 137.429 181.762 138.391C182.727 139.35 183.326 140.68 183.326 142.137C183.326 145.055 180.932 147.443 178.005 147.443L163.486 147.443C149.846 157.659 132.897 163.716 114.528 163.716C75.2973 163.716 42.5335 136.106 34.7114 99.309C44.7506 97.7773 55.3999 96.5463 66.5175 95.6478L67.3543 96.4083L68.1422 95.5204C81.4978 94.4839 95.5175 93.9321 109.977 93.9321C140.697 93.9321 169.445 96.4225 194.025 100.752C192.83 105.91 191.141 110.877 189.013 115.606L205.679 115.606C207.144 115.606 208.471 116.204 209.435 117.166C210.4 118.125 211 119.455 211 120.912"
                      fill="#E8EBF2"
                    />
                  </g>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M195.49 87.7376C195.189 92.1562 194.551 96.4769 193.605 100.678C169.052 96.2375 140.335 93.6839 109.648 93.6839C95.204 93.6839 81.1999 94.2495 67.8584 95.3124L77.1106 84.5923L91.5035 93.9846L110.987 88.605L144.504 93.6839L159.055 88.605L162.741 93.6839L171.533 87.1575L179.75 94.6884L192.708 84.3348L195.49 87.7376Z"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M67.8582 95.2302L67.1034 96.0084L66.3018 95.3417C66.818 95.3014 67.3383 95.2643 67.8582 95.2302"
                    fill="#F1F2F7"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M66.3019 95.4309C55.1854 96.3366 44.5371 97.5774 34.4989 99.1214C34.1549 97.4954 33.8605 95.8517 33.6157 94.1936L50.8222 81.2218L66.3019 95.4309Z"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M144.126 122.08C144.126 123.584 130.537 124.803 113.775 124.803C97.0116 124.803 83.4231 123.584 83.4231 122.08C83.4231 120.576 97.0116 119.356 113.775 119.356C130.537 119.356 144.126 120.576 144.126 122.08"
                    fill="#D8DBEA"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M193.934 147.372V147.372C190.937 147.372 188.486 144.921 188.486 141.925C188.486 138.928 190.937 136.477 193.934 136.477C196.93 136.477 199.381 138.928 199.381 141.925C199.381 144.921 196.93 147.372 193.934 147.372"
                    fill="#E1E3EF"
                  />
                  <g filter="url(#filter0_d_180_969)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M141.122 100.96H96.0958C92.9266 100.96 90.3325 98.3577 90.3325 95.1779V30.9687C90.3325 27.7889 92.9266 25.1884 96.0958 25.1884H141.122C144.292 25.1884 146.886 27.7889 146.886 30.9687V95.1779C146.886 98.3577 144.292 100.96 141.122 100.96"
                      fill="#E0E2EE"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M137.278 103.705H92.2523C89.0831 103.705 86.489 101.103 86.489 97.9233V33.714C86.489 30.5342 89.0831 27.9337 92.2523 27.9337H137.278C140.449 27.9337 143.043 30.5342 143.043 33.714V97.9233C143.043 101.103 140.449 103.705 137.278 103.705"
                      fill="#E8EBF2"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M133.54 105.872H88.4207C85.245 105.872 82.6455 103.281 82.6455 100.115V36.1711C82.6455 33.0045 85.245 30.4148 88.4207 30.4148H133.54C136.717 30.4148 139.316 33.0045 139.316 36.1711V100.115C139.316 103.281 136.717 105.872 133.54 105.872"
                      fill="#D8DBEA"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M133.54 105.872H88.4207C85.245 105.872 82.6455 103.281 82.6455 100.115V36.1711C82.6455 33.0045 85.245 30.4148 88.4207 30.4148H133.54C136.717 30.4148 139.316 33.0045 139.316 36.1711V100.115C139.316 103.281 136.717 105.872 133.54 105.872"
                      fill="#F1F2F7"
                    />
                  </g>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M146.202 76.6561C139.538 83.3188 129.222 84.0704 121.732 78.9263C120.775 78.2571 119.864 77.5055 119.014 76.6561C118.577 76.2202 118.165 75.7703 117.776 75.2967C116.999 74.3509 116.319 73.3422 115.761 72.2999C114.779 70.5396 114.111 68.6717 113.746 66.7409C112.57 60.6859 114.329 54.1685 119.014 49.4855C123.711 44.7885 130.229 43.0407 136.285 44.2059C138.215 44.5817 140.085 45.2495 141.845 46.2205C142.889 46.7905 143.884 47.4709 144.831 48.2477C145.304 48.6347 145.753 49.0482 146.189 49.4855C147.04 50.3349 147.803 51.2444 148.46 52.2028C153.606 59.6898 152.853 70.0059 146.202 76.6561"
                    fill="white"
                    fillOpacity="0.1"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M144.338 75.3439C137.405 82.278 126.17 82.2767 119.235 75.3439C112.31 68.4188 112.31 57.1822 119.244 50.2494C126.17 43.3243 137.405 43.3243 144.33 50.2494C151.263 57.1822 151.263 68.4188 144.338 75.3439M147.896 46.6874C138.997 37.7885 124.576 37.7885 115.677 46.6874C106.78 55.585 106.772 70.0144 115.67 78.9133C123.769 87.0098 136.463 87.74 145.391 81.0922C146.264 80.4421 147.103 79.7132 147.905 78.9133C148.704 78.1122 149.433 77.2724 150.082 76.4003C156.73 67.4704 155.993 54.7851 147.896 46.6874"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M182.916 112.458L182.543 112.832C180.071 115.304 176.024 115.304 173.551 112.832L150.729 90.0097L160.095 80.6441L182.916 103.466C185.389 105.939 185.389 109.985 182.916 112.458"
                    fill="url(#paint0_linear_180_969)"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M150.574 75.7025L157.318 82.4464L152.53 87.2329L145.788 80.4889C146.677 79.8255 147.533 79.0817 148.352 78.2655C149.168 77.4494 149.912 76.5924 150.574 75.7025"
                    fill="#E0E2EE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M182.575 103.185L173.269 112.49L171.594 110.813L180.898 101.509L182.575 103.185Z"
                    fill="#EF545F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M160.612 80.9663L151.052 90.5273L149.631 89.1069L159.192 79.5459L160.612 80.9663Z"
                    fill="url(#paint1_linear_180_969)"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M139.748 47.8641L116.301 71.31C115.418 69.7274 114.817 68.0481 114.491 66.3123L134.75 46.0529C136.484 46.392 138.165 46.9912 139.748 47.8641"
                    fill="white"
                    fillOpacity="0.5"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M147.435 53.437L122.086 77.3497C121.178 76.7521 120.314 76.0795 119.508 75.3193C119.094 74.928 118.701 74.5267 118.334 74.1029L143.992 49.8964C144.441 50.2439 144.868 50.614 145.281 51.0053C146.087 51.7654 146.812 52.5793 147.435 53.437"
                    fill="white"
                    fillOpacity="0.5"
                  />
                  <defs>
                    <filter
                      id="filter0_d_180_969"
                      x="78.6455"
                      y="25.1884"
                      width="72.2407"
                      height="88.6838"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_180_969"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_180_969"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_180_969"
                      x1="167.75"
                      y1="63.623"
                      x2="133.708"
                      y2="97.6651"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF8960" />
                      <stop offset="1" stopColor="#FF62A5" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_180_969"
                      x1="155.122"
                      y1="74.0553"
                      x2="144.14"
                      y2="85.0366"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF404E" />
                      <stop offset="1" stopColor="#FF62A5" />
                    </linearGradient>
                  </defs>
                </svg>

                <div className="px-8 mt-6 mb-6 text-center">
                  <h3 className="text-black text-lg font-semibold">
                    {this.state.msgTitleNoData}
                  </h3>
                  <p className="mt-4 text-sm text-gray-light">
                    {this.state.msgNoData}
                  </p>
                </div>
                {this.state.flagBuku && (
                  <>
                    <div className="flex justify-between px-4 items-center mt-4 mb-2">
                      <h3 className="text-base text-black font-semibold">
                        Buku Populer
                      </h3>
                    </div>
                    <div className="pl-4 mb-50">
                      <Glider slidesToShow="3.3" slidesToScroll="1" draggable>
                        {/* <!-- Item Book --> */}
                        {this.state.data.length > 0 && this.state.flagBuku && (
                          <>
                            {this.state.data.map((item) => {
                              if (item.alias != this.state.params.id) {
                                return (
                                  <>
                                    <div className="p-1">
                                      <div className="rounded-xl shadow-md hover:shadow-lg duration-150 ease-out cursor-pointer">
                                        <div
                                          className="h-[140px] overflow-hidden"
                                          onClick={() =>
                                            this.gotoDetail(item.alias)
                                          }
                                        >
                                          <img
                                            src={item.cover_file}
                                            alt="cover buku"
                                            className="rounded-xl"
                                          />
                                        </div>
                                        <div className="p-2 min-h-[120px]">
                                          <div className="title-book text-sm text-black font-semibold line-clamp-2">
                                            {item.judul}
                                          </div>
                                          <div className="author mt-1 text-xs text-gray-light line-clamp-1">
                                            {item.penulis}
                                          </div>
                                          <div className="publisher mt-1 text-xs text-gray-light line-clamp-1">
                                            {item.penerbit}
                                          </div>
                                          <div className="stock mt-1 text-sm text-orange font-semibold">
                                            Stok: {item.terpakai}/{item.qty}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            })}
                          </>
                        )}
                      </Glider>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        )}
      </>
    );
  }
}

export default WithNavigate;
